import { hasDescription, hasEndDatetime, hasTitle } from '../tasks';
import type { PreparedNewProjectTask } from './types';

export const newEntityReady = (task: PreparedNewProjectTask) =>
  hasTitle(task) && hasEndDatetime(task) && hasDescription(task);
